// Axios and configuration
import axios from "axios";
import AxiosConfig from "src/utilities/AxiosConfig";

// Interfaces
import I_BaseAPIResponse from "src/common_interfaces/I_BaseAPIResponse";
import { I_CreateApprovalWorkflow } from "../interfaces";

// Utilities
import snackBar from "src/utilities/snackBar/SnackBar";

/**
 * Sends a request to create a new approval workflow.
 *
 * @param payload - The data needed to create the workflow
 * @returns A boolean indicating whether the creation was successful
 */
const CreateApprovalWorkflow = async (
  payload: I_CreateApprovalWorkflow
): Promise<boolean> => {
  try {
    const response = await axios.post<I_BaseAPIResponse<string>>(
      `${process.env.REACT_APP_API_URL}/api/approval/workflow`,
      payload,
      AxiosConfig.configValue("min")
    );

    if (response.data.HasError) {
      snackBar({
        type: "error",
        text: response.data.ErrorMessage,
        timeout: 4000,
      });
      return false;
    }

    return true;
  } catch (error) {
    console.error("CreateApprovalWorkflow failed:", error);
    snackBar({
      type: "error",
      text: "Failed to create workflow",
      timeout: 4000,
    });
    return false;
  }
};

export default CreateApprovalWorkflow;
